import { useLocation, useNavigate } from 'react-router-dom'
import { useMemo } from 'react'
import { useStudioStore } from '@/store'
import { BarChart3, BookOpenCheck, Megaphone } from 'lucide-react'
import { confirmLeaveUnsavedChanges } from '@/lib/unsavedChanges'

export function StudioOwnerNavigation() {
  const location = useLocation()
  const navigate = useNavigate()
  const { studios, selectedPartnerNumber } = useStudioStore()

  const partnerNumber = useMemo(() => {
    const partnerFromStore = selectedPartnerNumber
    const partnerFromStudios = studios.find(
      (studio) => studio.partner_number !== null && studio.partner_number !== undefined
    )?.partner_number
    return partnerFromStore ?? partnerFromStudios ?? null
  }, [selectedPartnerNumber, studios])

  const analyticsPath = partnerNumber !== null && partnerNumber !== undefined
    ? `/partners/${partnerNumber}/analytics`
    : '/partners'

  const marketingPath = partnerNumber !== null && partnerNumber !== undefined
    ? `/partners/${partnerNumber}/marketing`
    : '/partners'

  const canAccessMarketing = partnerNumber !== null && partnerNumber !== undefined && studios.some((studio) => (
    Number(studio.partner_number) === Number(partnerNumber)
      && (studio.role === 'owner' || studio.role === 'manager' || studio.access_kind === 'management_company')
  ))

  const pedagogyStudio = studios.find((studio) => (
    (partnerNumber === null || Number(studio.partner_number) === Number(partnerNumber))
      && (studio.role === 'manager' || studio.role === 'owner' || studio.role === 'senior_teacher'
        || studio.access_kind === 'management_company' || studio.access_kind === 'senior_teacher')
  ))
  const pedagogyPath = pedagogyStudio && partnerNumber !== null && partnerNumber !== undefined
    ? `/partners/${partnerNumber}/studios/${pedagogyStudio.studio_internal_id}/teachers`
    : '/partners'

  const navItems = [
    {
      path: analyticsPath,
      icon: BarChart3,
      label: 'Аналитика',
      enabled: true
    },
    {
      path: marketingPath,
      icon: Megaphone,
      label: 'Маркетинг',
      enabled: canAccessMarketing
    },
    {
      path: pedagogyPath,
      icon: BookOpenCheck,
      label: 'Педагоги',
      enabled: Boolean(pedagogyStudio)
    }
    // {
    //   path: '/settings/notifications',
    //   icon: Bell,
    //   label: 'Уведомления',
    //   enabled: true
    // }
  ]

  return (
    <div className="fixed bottom-0 left-0 right-0 z-30 bg-card border-t border-border px-4 py-2 tg-navigation">
      <div className="flex justify-around">
        {navItems.map((item) => {
          if (!item.enabled) return null
          
          const Icon = item.icon
          const isAnalyticsActive = /^\/partners\/[^/]+\/analytics$/.test(location.pathname) || location.pathname === '/analytics'
          const isMarketingActive = /^\/partners\/[^/]+\/marketing(\/.*)?$/.test(location.pathname)
          const isPedagogyActive = /^\/partners\/[^/]+\/studios\/[^/]+\/(teachers|trainer-reviews)(\/.*)?$/.test(location.pathname)
          const isActive =
            item.label === 'Аналитика'
              ? isAnalyticsActive
              : item.label === 'Маркетинг'
                ? isMarketingActive
                : item.label === 'Педагоги'
                  ? isPedagogyActive
                : location.pathname === item.path
          
          return (
            <button
              key={item.path}
              onClick={() => {
                if (!confirmLeaveUnsavedChanges()) return
                navigate(item.path)
              }}
              disabled={isActive}
              className={`
                flex flex-col items-center p-2 rounded-lg transition-colors
                ${isActive 
                  ? 'text-primary bg-primary/10' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }
              `}
            >
              <Icon className="w-5 h-5 mb-1" />
              <span className="text-xs">{item.label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
